<template lang="">
    <Intro bgUrl="background-image: url('images/contactUs.jpg');">
             <!-- we will get this using -->
            <div class="title">
                <h3>Politique de confidentialité</h3>
            </div>
            <div class="content">
                <h4>by Securelabs</h4>
            </div>
            <div class="action">
                <a href="#contact-form">Découvrir</a>
            </div>
    </Intro>
    <main class="pt-5 mb-5 container">
        <img class="activity-box-icon my-5" src="images/Politique de Conf/compliant.png" alt="">
        <p class="activity-listing-subtitle">
            Conformément à la loi Informatique et Libertés n°78-17 du 6 janvier 1978 modifiée et au Règlement Général sur la Protection des Données à caractère personnel (ci-après « RGPD ») n° 2016/679/UE du 27 avril 2016, SECURELABS, en qualité de responsable de traitement, garantit le respect de la vie privée des Utilisateurs du Site.

L’Utilisateur, personne physique, est informé que les informations qu’il communique par le biais du Site sur la base, soit de mesures précontractuelles ou de l’exécution d’un contrat, soit de l’intérêt légitime poursuivi par SECURELABS afin de pouvoir répondre à ses demandes, sont destinées aux services habilités de SECURELABS à des fins de gestion des relations clients et prospects.
Pendant la consultation du Site ou l’accès aux services en ligne de SECURELABS, l’Utilisateur peut être sollicité pour communiquer volontairement certaines données personnelles (nom, prénom, société, courriel, email, numéro de téléphone, identifiants).
Les formulaires de collecte présents sur le Site précisent notamment la finalité, les destinataires, la durée de conservation et le caractère obligatoire ou facultatif des données demandées par un astérisque.
Les données personnelles collectées et traitées sur le Site sont protégées par des mesures techniques et organisationnelles appropriées afin de garantir un niveau de sécurité adapté au risque.
L’Utilisateur du Site est informé qu’il dispose d’un droit d’accès, de rectification, de suppression, de limitation, et d’opposition sur les données le concernant. L’Utilisateur peut exercer ces droits en s’adressant au service DPO de SECURELABS à l’adresse dpo@securelabs-cybersecurite.com.
L’Utilisateur dispose également du droit d’introduire une réclamation auprès de la CNIL.
        </p>
        <div class="mt-3">© SECURELABS – tous droits réservés</div>
    </main>
</template>
<script>
import Intro from '@/components/Intro'
    export default {
      components:{
            Intro
        }  
    }
</script>
<style>
    
</style>